'use strict';

angular.module('mean.bids').factory('bidRequestEditService', ['$filter',
    function($filter) {
        //bid is the bid list from the tradeBid
        //task_list is from the same tradeBid's task list
        var getMaterials = function(bid, task_list) {
            var materials = [];

            for(var i=0; i<bid.length; i++) {
                var task = $filter('filter')(task_list, {
                    '_id': bid[i].task_id}, true);

                for(var j=0; j<task[0].subtasks.length; j++) {
                    var bidt = $filter('filter')(bid[i].subtasks, {
                        'task_id': task[0].subtasks[j]._id }, true);
                    for(var k=0; k<task[0].subtasks[j].materials.length; k++) {
                        var matq = $filter('filter')(bidt[0].materials, {
                            'material_id': task[0].subtasks[j].materials[k]._id}, true);

                        if(matq.length !== 1) continue;

                        var inlist = $filter('filter')(materials, {
                            'task': task[0].task, 
                            'name': task[0].subtasks[j].materials[k].name,
                            'note': task[0].subtasks[j].materials[k].note,
                            'plan_code': bid[i].plan_code,
                            'price_per_order': matq[0].price_per_order }, true);
                        if(inlist.length === 0) {
                            materials.push(angular.copy(task[0].subtasks[j].materials[k]));
                            if(materials[materials.length-1].is_overridden) {
                                materials[materials.length-1].quantity = 
                                    materials[materials.length-1].overridden_quantity;
                            } else {
                                materials[materials.length-1].quantity = 
                                    matq[0].quantity ? matq[0].quantity : matq[0].quantity_allowed;
                            }
                            materials[materials.length-1].task = task[0].task;
                            materials[materials.length-1].plan_code = bid[i].plan_code;
                            materials[materials.length-1].task_id = bid[i].task_id;
                            materials[materials.length-1].subtask_id = bid[i].subtasks[j].task_id;
                        } else {
                            inlist[0].quantity += matq[0].quantity ? matq[0].quantity : matq[0].quantity_allowed;
                        }
                    }
                }
            }

            return materials;
        };

        var getEquipment = function(bid, task_list) {
            var equipment = [];

            for(var i=0; i<bid.length; i++) {
                var task = $filter('filter')(task_list, {
                    '_id': bid[i].task_id}, true);

                for(var j=0; j<task[0].subtasks.length; j++) {
                    var bidt = $filter('filter')(bid[i].subtasks, {
                        'task_id': task[0].subtasks[j]._id }, true);
                    for(var k=0; k<task[0].subtasks[j].equipment.length; k++) {
                        var matq = $filter('filter')(bidt[0].equipment, {
                            'material_id': task[0].subtasks[j].equipment[k]._id}, true);

                        if(matq.length !== 1) continue;

                        var inlist = $filter('filter')(equipment, {
                            'task': task[0].task, 
                            'name': task[0].subtasks[j].equipment[k].name,
                            'note': task[0].subtasks[j].equipment[k].note,
                            'plan_code': bid[i].plan_code,
                            'price_per_order': matq[0].price_per_order }, true);
                        if(inlist.length === 0) {
                            equipment.push(angular.copy(task[0].subtasks[j].equipment[k]));
                            if(equipment[equipment.length-1].is_overridden) {
                                equipment[equipment.length-1].quantity = 
                                    equipment[equipment.length-1].overridden_quantity;
                            } else {
                                equipment[equipment.length-1].quantity = 
                                    matq[0].quantity ? matq[0].quantity : matq[0].quantity_allowed;
                            }
                            equipment[equipment.length-1].task = task[0].task;
                            equipment[equipment.length-1].plan_code = bid[i].plan_code;
                            equipment[equipment.length-1].task_id = bid[i].task_id;
                            equipment[equipment.length-1].subtask_id = bid[i].subtasks[j].task_id;
                        } else {
                            inlist[0].quantity += matq[0].quantity ? matq[0].quantity : matq[0].quantity_allowed;
                        }
                    }
                }
            }

            return equipment;
        };

        return {
            getMaterials: getMaterials,
            getEquipment: getEquipment
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/bid-request-edit-service.js